import { render, staticRenderFns } from "./RecordFollowUpSequenceForm.vue?vue&type=template&id=7479f063&scoped=true&"
import script from "./RecordFollowUpSequenceForm.vue?vue&type=script&lang=js&"
export * from "./RecordFollowUpSequenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479f063",
  null
  
)

export default component.exports